<div class="address-office mb-footer">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 my-md-5 mb-5 sec-title">
                <div class="comp-title-page">
                    <div class="row">
                        <!-- title -->
                        <div class="col-lg-7 col-md-6 left order-md-1 order-2">
                            <div class="position-relative h-100">
                                <div class="w-title mb-md-0 mb-5">
                                    <h2 class="fw-400 mb-0" [innerHTML]="dataTitle?.title"></h2>
                                </div>
                                <div class="con-address" *ngIf="dataAddress">
                                    <div class="ad-tab px-3 mb-1 py-2 active" (click)="tabAddress($event,0)">
                                        <h6 class="office">{{ dataAddress[0]?.title }}</h6>
                                        <p class="mb-0 mini">{{ dataAddress[0]?.subtitle }}</p>
                                    </div>
                                    <div class="ad-tab px-3 mb-1 py-2" (click)="tabAddress($event,1)">
                                        <h6 class="office">{{ dataAddress[1]?.title }}</h6>
                                        <p class="mb-0 mini">{{ dataAddress[1]?.subtitle }}</p>
                                    </div>
                                    <div class="address pt-3 px-3">
                                        <div class="location pb-3 d-flex">
                                            <div class="pr-4"><i class="icon ion-md-pin"></i></div>
                                            <div [innerHTML]="dataCurAddress.location"></div>
                                        </div>
                                        <div class="telephone pb-3 d-flex">
                                            <div class="pr-4"><i class="icon ion-md-call"></i></div>
                                            <p>{{ dataCurAddress.telp }}</p>
                                        </div>
                                        <div class="print d-flex">
                                            <div class="pr-4"><i class="icon ion-md-print"></i></div>
                                            <p>{{ dataCurAddress.fax }}</p>
                                        </div>
                                    </div>
                                 </div>
                            </div>
                        </div>
                        <!-- picture -->
                        <div class="col-lg-5 col-md-6 px-md-3 px-0 right order-md-2 order-1">
                            <img [src]="apiAsset + dataCurAddress?.picture" class="w-100" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <!-- contents -->
            <div class="col-md-12 sec-contents">
                <div class="lane-top">
                    <h4 class="fw-400 f-mtit my-5">{{ dataSection[0]?.title }}</h4>
                    <div class="row" *ngIf="dataSection[0]?.card.length != 0">
                        <div class="col-md-10 mx-auto">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="border-type-1 w-ad no-list li-2 p-3" 
                                        [innerHTML]="address.description"
                                        *ngFor="let address of dataSection[0]?.card | slice:0:3"></div>
                                </div>
                                <div class="col-md-6 mt-4 mt-md-0">
                                    <div class="border-type-1 h-100 w-ad no-list li-2 p-3" [innerHTML]="dataSection[0]?.card[3].description"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </div>
</div>


